import React from 'react';

const DashboardIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor'>
      <path d='M13 17c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H7c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2h6zm12 0c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-4c0-1.105.895-2 2-2h6zM13 7c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2H7c-1.105 0-2-.895-2-2V9c0-1.105.895-2 2-2h6zm12 0c1.105 0 2 .895 2 2v4c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2V9c0-1.105.895-2 2-2h6z' />
    </g>
  </svg>
);

export default DashboardIcon;
